import { render, staticRenderFns } from "./DiscountLvList.vue?vue&type=template&id=53a550ea&scoped=true&"
import script from "./DiscountLvList.vue?vue&type=script&lang=js&"
export * from "./DiscountLvList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLvList.vue?vue&type=style&index=0&id=53a550ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a550ea",
  null
  
)

export default component.exports